import Modal from '../../../general/js/modal';
import eventBus from '../../../general/js/event-bus';
import BaseComponent from '../../../general/js/base-component';
import {EVENT_AUTH_TRIGGER_CLICK} from "../../../general/js/app";

export default class AuthModalComponent extends BaseComponent{
    constructor() {
        super(...arguments);
        this.modal = null;

        this.init();
    }

    init() {
        this.triggerClickSubscription = eventBus.addListener(EVENT_AUTH_TRIGGER_CLICK, this.showModal.bind(this));
    }

    showModal() {
        if (this.modal === null) {
            this.modal = Modal.create(this.element)
        }

        this.modal.open();
    }

    onDestroy() {
        this.triggerClickSubscription.remove();
        this.modal = null;
    }
}



// WEBPACK FOOTER //
// ./app/components/auth-modal/js/auth-modal.component.js